var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank__data"},[_c('img',{attrs:{"src":_vm.bank}}),_c('div',{staticClass:"text"},[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }